import OnboardService from "@/services/OnboardService";
export const ExpenseStore = {
  leanLawApi: undefined
};
export default class ExpenseService {
  constructor(leanLawApi, userService, alerts) {
    this.leanLawApi = leanLawApi;
    this.userService = userService;
    this.alerts = alerts;
    if (!ExpenseStore.leanLawApi) {
      ExpenseStore.leanLawApi = leanLawApi;
    }
  }
  load(e) {
    const expense = angular.copy(e);
    // api comes back with time which sometimes flips date to
    // previous date depending on browser time zone. Sorting it out this way
    const parts = expense.date.substring(0, 10).split('-');
    expense.date = new Date(parts[0], parts[1] - 1, parts[2]);
    expense.$original = e;
    return expense;
  }
  undo(expense) {
    return this.load(expense.$original);
  }
  delete(id) {
    return ExpenseStore.leanLawApi.deleteExpense({
      id
    });
  }
  update(update) {
    return ExpenseStore.leanLawApi.updateExpense({
      id: update.id,
      body: update
    });
  }
  create(matter, create, hideAlert) {
    return ExpenseStore.leanLawApi.createMatterExpense({
      id: matter.id,
      body: {
        ...create,
        date: create.date.toNetworkDate(),
        method: 'Equitrac import'
      }
    }).then(e => {
      if (!hideAlert) this.alerts.success(`The expense was successfully created`);
      new OnboardService(this.userService, this.leanLawApi).reload();
      return this.load(e);
    });
  }
  listForMatter(matterId, request) {
    if (!request) request = {
      accounting: false,
      billed: false
    };
    request.id = matterId;
    return ExpenseStore.leanLawApi.listMatterExpenses(request).then(e => this.processExpenseList(e));
  }
  listForClient(clientId, request) {
    if (!request) request = {
      accounting: false,
      billed: false
    };
    request.id = clientId;
    return ExpenseStore.leanLawApi.listClientExpenses(request).then(e => this.processExpenseList(e));
  }
  processExpenseList(list) {
    return list.expenses.map(e => this.load(e));
  }
  get(id) {
    return ExpenseStore.leanLawApi.getExpense({
      id
    }).then(e => this.load(e));
  }
}